import { styled } from '@mui/material/styles';

export const SidebarContainer = styled('aside')(({ open }) => ({
  width: '250px',
  height: '100vh',
  position: 'fixed',
  top: 0,
  left: 0,
  backgroundColor: 'var(--primary-main)',
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)',
  transition: 'transform 0.3s ease',
  zIndex: 1000,
  
  '@media (max-width: 768px)': {
    transform: open ? 'translateX(0)' : 'translateX(-100%)',
    width: '280px',
  },
}));

export const Backdrop = styled('div')(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 999,
  display: 'none',
  
  '@media (max-width: 768px)': {
    display: 'block',
  },
}));

export const Logo = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '25px 20px',
  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
  position: 'relative',
}));

export const LogoText = styled('h1')(() => ({
  fontSize: '1.5rem',
  fontWeight: 700,
  marginLeft: '10px',
  color: 'var(--secondary-main)',
}));

export const MobileMenuButton = styled('button')(() => ({
  display: 'none',
  position: 'absolute',
  right: '15px',
  top: '50%',
  transform: 'translateY(-50%)',
  background: 'none',
  border: 'none',
  color: '#fff',
  cursor: 'pointer',
  
  '@media (max-width: 768px)': {
    display: 'block',
  },
}));

export const SidebarContent = styled('div')(() => ({
  flex: 1,
  overflow: 'auto',
  padding: '20px 0',
}));

export const SidebarNav = styled('nav')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
}));

export const NavItem = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isActive'
})(({ isActive }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '12px 20px',
  cursor: 'pointer',
  borderLeft: isActive ? `4px solid var(--secondary-main)` : '4px solid transparent',
  backgroundColor: isActive ? 'rgba(255, 255, 255, 0.05)' : 'transparent',
  
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
}));

export const NavItemIcon = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isActive'
})(({ isActive }) => ({
  color: isActive ? 'var(--secondary-main)' : 'rgba(255, 255, 255, 0.6)',
  display: 'flex',
  alignItems: 'center',
  marginRight: '15px',
}));

export const NavItemText = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ isActive }) => ({
  fontWeight: isActive ? 600 : 400,
  fontSize: '0.8rem',
  letterSpacing: '0.5px',
  textTransform: 'capitalize',
  paddingLeft: '10px',
  color: isActive ? 'var(--secondary-main)' : 'rgba(255, 255, 255, 0.8)',
  
}));


export const SidebarFooter = styled('div')(() => ({
  padding: '15px 20px',
  borderTop: '1px solid rgba(255, 255, 255, 0.1)',
}));

export const FooterText = styled('p')(() => ({
  fontSize: '0.75rem',
  color: 'rgba(255, 255, 255, 0.5)',
}));

export const LogoutButton = styled('button')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  background: 'transparent',
  color: '#f44336',
  border: '1px solid #f44336',
  borderRadius: '4px',
  padding: '8px 12px',
  marginBottom: '12px',
  cursor: 'pointer',
  fontSize: '14px',
  transition: 'all 0.2s ease',
  width: '100%',
  justifyContent: 'center',

  '&:hover': {
    background: '#f44336',
    color: 'white',
  },

  '& svg': {
    fontSize: '18px',
  }
}));